<template>

    <Page>

        <ImageAndText 
            animation="zoom"
            src="/WorkOrders/procedure.jpg"
            border
            image-class="rounded-xl"
            floor-shadow>

            <h2 class="mb-2">Work Order Procedure</h2>
            <p class="font-normal text-base">
                Carbucks PROTECT Work Orders must be approved by the Concierge Service prior 
                to carrying out any repair or replacement of eligible parts. Work Orders that 
                meet the eligibility criteria will be approved over the phone.
            </p>
            <ul class="mt-3 list-decimal pl-6 font-normal text-white/80 text-base">
                <li>Call the <strong>Carbucks Concierge</strong> on <strong class="text-emerald-500">1800 13 13 18</strong></li>
                <li>Describe what is being requested:</li>
                <ul class="ml-6 list-disc list-inside font-normal text-white/80">
                    <li>Key Fob Repair</li>
                    <li>Wiper Blade Replacement</li>
                    <li>Tyre Safety</li>
                    <li>12v Battery Replacement</li>
                    <li>Brake Safety</li>
                </ul>
                <li>Concierge will email a PO for the Work Order</li>
                <li>Email the Concierge Service evidence of the work required and an invoice for the Work Order to
                    <strong class="text-emerald-500">concierge@carbucks.com.au</strong>
                </li>
            </ul>
            <p class="font-normal text-base mt-6">
                Once the Work Order has been carried out, and all documents have been received, 
                the Concierge Service will send the dealership and customer a copy of the 
                Work Order Confirmation.
            </p>

        </ImageAndText>

    </Page>

</template>